// extracted by mini-css-extract-plugin
export var box = "_4o-0";
export var check = "_4o-1";
export var checkboxButton = "_4o-6";
export var checkboxGroup = "_4o-5";
export var disabled = "_4o-7";
export var ghost = "_4o-9";
export var input = "_4o-2";
export var label = "_4o-4";
export var normal = "_4o-8";
export var uncheck = "_4o-3";